import { FormGroup } from '@/components/FormGroup';

import Details from './Detail';

const ReviewMode = () => {
  return (
    <FormGroup collapsable={false} showValidationState={false} reviewMode={true}>
      <Details />
    </FormGroup>
  );
};

export default ReviewMode;
